<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="锁编号：" prop="shell_num">
                <el-input v-model="model.shell_num"></el-input>
            </el-form-item>
            <el-form-item label="锁序列号：" prop="lock_sn">
                <el-input v-model="model.lock_sn"></el-input>
            </el-form-item>
            <el-form-item label="锁证书链：" prop="device_certs">
                <el-input v-model="model.device_certs"></el-input>
            </el-form-item>
            <el-form-item label="持有人：" prop="holder">
                <el-input v-model="model.holder"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'cryptoDogEdit',
    mixins: [editutil],
    data() {
        return {
            exits_p_name:'shell_num',
            exits_p_title:'锁编号',
            model: {
                shell_num: '',
                lock_sn: '',
                device_certs: '',
                holder: '',
                remark: '',
                bind_user_count: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
            },
            getObj:{
                url:'/api/admin/cryptodog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            checkObj:{
                url:'/api/admin/cryptodog/check',
                data:{}
            },
            exits_p_name:'shell_num',
            exits_p_title:'锁编号',
            rules: {
                shell_num: [
                    {required: true, message: '锁编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                lock_sn: [
                    {required: true, message: '锁序列号不能为空', trigger: 'blur'},
                ],
                device_certs: [
                    {required: true, message: '锁证书链不能为空', trigger: 'blur'},
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/cryptodog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>